import {
  logout,
  getUserInfo,
  login
} from '@/api/admin/login'
import {
  setToken,
  removeToken,
  setRefreshToken,
  removeRefreshToken,
} from '@/utils/auth'
import { setStore, getStore } from '@/utils/store'
import { TOKEN, USERINFO, REFRESH_TOKEN, ROLES, PERMISSIONS, TENANTCODE, SYS_CONFIG } from '@/utils/storeMap'
import {switchCompanyLogin} from "@/api/pc/personal";

const user = {
  state: {
    userInfo: {},
    permissions: getStore({
      name: PERMISSIONS
    }) || {},
    roles: getStore({
      name: ROLES
    }) || [],
    menu: getStore({
      name: 'menu'
    }) || [],
    isInitMenu: getStore({
      name: 'isInitMenu'
    }) || false,
    token: getStore({
      name: TOKEN
    }) || '',
    refresh_token: getStore({
      name: REFRESH_TOKEN
    }) || '',
    tenantCode: getStore({
      name: TENANTCODE
    }) || '',
    sysConfig: getStore({
      name: SYS_CONFIG
    }) || ''
  },
  actions: {
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      const type = userInfo.type
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid, type).then(res => {
          let data = res.data
          setToken(data.access_token)
          setRefreshToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          commit('SET_REFRESH_TOKEN', data.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    CompanyChange({ commit }, id) {
      return new Promise((resolve, reject) => {
        switchCompanyLogin(id).then(res => {
          let data = res.data
          setToken(data.access_token)
          setRefreshToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          commit('SET_REFRESH_TOKEN', data.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserInfo ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          const data = response;
          commit('SET_ROLES', data.roles)
          commit('SET_USER_INFO', data.user)
          commit('SET_PERMISSIONS', data.permissions)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_USER_INFO', {})
          commit('SET_PERMISSIONS', [])
          removeToken()
          removeRefreshToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_PERMISSIONS', [])
        commit('SET_USER_INFO', {})
        commit('SET_TOKEN', '')
        commit('SET_REFRESH_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_SYS_CONFIG', {})
        commit('SET_TENANT_CODE', {})
        removeRefreshToken()
        resolve()
      })
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setStore({
        name: TOKEN,
        content: state.token
      })
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setStore({
        name: USERINFO,
        content: state.userInfo
      })
    },
    SET_REFRESH_TOKEN: (state, rfToken) => {
      state.refresh_token = rfToken
      setStore({
        name: REFRESH_TOKEN,
        content: state.refresh_token
      })
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
      setStore({
        name: ROLES,
        content: state.roles
      })
    },
    SET_PERMISSIONS: (state, permissions) => {
      const list = {}
      for (let i = 0; i < permissions.length; i++) {
        list[permissions[i]] = true
      }
      state.permissions = list
      setStore({
        name: PERMISSIONS,
        content: state.permissions
      })
    },
    SET_TENANT_CODE: (state, tenantCode) => {
      state.tenantCode = tenantCode
      setStore({
        name: TENANTCODE,
        content: state.tenantCode
      })
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js